import { all, call, put, takeLatest } from 'typed-redux-saga/macro';
import { DEVICESETS_URL } from '../../constants/api.constants';
import { apiRequestWrapper } from '../../utils/api/api.utils';
import { setIsError } from '../error/error.action';
import { setIsLoading } from '../loading/loading.action';
import { getDevicesetsFailed, GetDevicesetsStart, getDevicesetsStatusFailed, GetDevicesetsStatusStart, getDevicesetsStatusSuccess, getDevicesetsSuccess } from './deviceset.action';
import { DEVICESET_ACTION_TYPES } from './deviceset.types';


export function* getDevicesets({
    payload: { devicesetId, onComplete },
}: GetDevicesetsStart) {
    yield* put(setIsLoading(true));
    try {
        let devicesetsUrl = DEVICESETS_URL;
        if (devicesetId) {
            devicesetsUrl += `${devicesetId}/`;
        }
        const devicesetsResponse = yield* call(
            apiRequestWrapper, devicesetsUrl, 'GET', null
        );
        if (devicesetsResponse) {
            yield* put(getDevicesetsSuccess());
            onComplete(devicesetsResponse);
        }
        yield* put(setIsLoading(false));
    } catch (error: any) {
        const errorResponse = error.response?.data?.error_description ??
            error.response?.data?.error ?? error.response?.data?.detail ?? error.message ?? 'Errore server';
        yield* put(getDevicesetsFailed(errorResponse));
        yield* put(setIsLoading(false));
        yield* put(setIsError(true, errorResponse));
    }
}

export function* getDevicesetsStatus({
    payload: { devicesetId, onComplete },
}: GetDevicesetsStatusStart) {
    try {
        let devicesetsUrl = DEVICESETS_URL;
        if (devicesetId) {
            devicesetsUrl += `${devicesetId}/`;
        }
        devicesetsUrl += 'status-severity/';
        const statusResponse = yield* call(
            apiRequestWrapper, devicesetsUrl, 'GET', null
        );
        if (statusResponse) {
            yield* put(getDevicesetsStatusSuccess());
            onComplete(statusResponse);
        }
    } catch (error: any) {
        const errorResponse = error.response?.data?.error_description ??
            error.response?.data?.error ?? error.response?.data?.detail ?? error.message ?? 'Errore server';
        yield* put(getDevicesetsStatusFailed(errorResponse));
        yield* put(setIsError(true, errorResponse));
    }
}

export function* onGetDevicesetsStart() {
    yield* takeLatest(DEVICESET_ACTION_TYPES.GET_DEVICESETS_START, getDevicesets);
}

export function* onGetDevicesetsStatusStart() {
    yield* takeLatest(DEVICESET_ACTION_TYPES.GET_DEVICESETS_STATUS_START, getDevicesetsStatus);
}

export function* devicesetSaga() {
    yield* all([
        call(onGetDevicesetsStart),
        call(onGetDevicesetsStatusStart),
    ]);
}
